import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';

@customElement('as-application-header')
export class ApplicationHeader extends LitElement {
  public static styles = css`
    .application-header {
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 16px;
      padding-bottom: 8px;
      box-sizing: border-box;
      z-index: 10;
      color: #212529;
    }

    .application-header-logo {
      flex: 0 0 auto;
      margin-right: 16px;
    }

    .application-header-logo img {
      display: block;
      max-height: 40px;
    }

    .application-header-subtitle {
      flex: 1 1;
      margin-right: 16px;
      font-size: 1.2rem;
    }

    .application-header-items {
      flex: 0 0 auto;
      display: flex;
      flex-direction: row;
    }
  `;

  @property()
  public logo!: string;

  @property()
  public logoAlt!: string;

  @property()
  public subtitle!: string;

  public render() {
    return html`<div class="application-header">
      <div class="application-header-logo">
        <img src="${this.logo}" alt="${this.logoAlt}" />
      </div>
      <div class="application-header-subtitle">${this.subtitle}</div>
      <div class="application-header-items">
        <slot name="items"></slot>
      </div>
    </div>`;
  }
}
